import { UserModel } from '../modules/auth/models/UserModel';
import { Permission } from './types';

const fetchPermission =
  (user: UserModel | any) =>
  async (permission: Permission): Promise<boolean> => {
    // Eğer permission içinde || varsa, herhangi birinin olması yeterli
    if (permission.includes('||')) {
      const permissions = permission.split('||').map((p) => p.trim());
      return permissions.some((p) => user?.authorization_keys?.includes(p));
    }
    // Tek permission kontrolü
    return user?.authorization_keys?.includes(permission) ?? false;
  };
export default fetchPermission;
